import { Component, Input, OnInit } from '@angular/core';
import { BroadcastKey, BroadcastService } from '@services/broadcast/';
import { ISystemAlert, SystemAlertsService } from '@services/system-alerts/';
import { componentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import each from 'lodash/each';
import filter from 'lodash/filter';
import last from 'lodash/last';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-system-alert-badge',
	templateUrl: './alert-badge.component.html',
	styleUrls: ['./alert-badge.component.scss']
})
export class AlertBadgeComponent extends OnDestroyMixin implements OnInit {
	@Input() ids: string[]; // limit to alerts with IDs

	alerts: ISystemAlert[] = [];

	constructor(private systemAlertsService: SystemAlertsService, private broadcastService: BroadcastService) {
		super();
	}

	get displayAlert(): ISystemAlert {
		return last(this.alerts);
	}

	ngOnInit(): void {
		this.broadcastService
			.on<ISystemAlert>(BroadcastKey.system_alert_new)
			.pipe(takeUntil(componentDestroyed(this)))
			.subscribe((alert: ISystemAlert) => {
				this.addAlert(alert);
			});

		this.broadcastService
			.on<ISystemAlert>(BroadcastKey.system_alert_cancelled)
			.pipe(takeUntil(componentDestroyed(this)))
			.subscribe((alert: ISystemAlert) => {
				this.removeAlert(alert);
			});

		this.addAlerts(this.systemAlertsService.allAlerts);
	}

	private addAlerts(alerts: ISystemAlert[]) {
		each(alerts, (alert: ISystemAlert) => {
			this.addAlert(alert);
		});
	}

	private addAlert(alert: ISystemAlert) {
		// only add alerts if it is listed in alert Ids list
		if (this.ids && this.ids.includes(alert.id)) {
			this.alerts.push(alert);
		}
	}

	private removeAlert(alert: ISystemAlert) {
		this.alerts = filter(this.alerts, (a) => {
			return a.id !== alert.id;
		});
	}
}
